import { Entry } from 'contentful';
import {
  TypeProductPageFields,
  TypeCollectionMarketingCardFields,
} from '@/core/generated-types';

export const orderedPages = (
  productPages: Entry<TypeProductPageFields>[],
  marketingPages: Entry<TypeCollectionMarketingCardFields>[],
) => {
  const combinedPages = [...productPages, ...marketingPages];
  const result = [];

  for (const page of combinedPages) {
    const fields = page.fields as unknown as TypeCollectionMarketingCardFields;
    if (fields.listedOrder !== undefined) {
      const index = fields.listedOrder - 1;
      result.splice(index, 0, page);
    } else {
      result.push(page);
    }
  }

  return result.filter(Boolean);
};
